import { type Locker } from '../../storage/lock';
import type { IDBConnection } from './db';

/**
 * Exclusive lock per IndexedDB database and resource, shared by every tab
 * and worker of the origin through the Web Locks API. The browser frees a
 * lock when its holder releases it or when the holding context ends (a
 * reload, a closed tab, a stopped worker). Nothing about a lock is stored in
 * the database, so no lock outlives its holder.
 */
export class IndexedDBLocker implements Locker {
  constructor(private readonly dbConnection: IDBConnection) {}

  async lock(domain: string, resource: string): Promise<AsyncDisposable> {
    const name = `idb:${this.dbConnection.dbName}:${domain}:${resource}`;
    let release!: () => void;
    const held = new Promise<void>(resolve => {
      release = resolve;
    });
    await new Promise<void>((acquired, refused) => {
      navigator.locks
        .request(name, () => {
          acquired();
          return held;
        })
        .catch(refused);
    });
    return {
      [Symbol.asyncDispose]: async () => release(),
    };
  }
}
